import { useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CheckOut from '../features/checkout/CheckOut';
import Summarys from '../features/checkout/Summarys';
import ScrollToTop from '../Component/ScrollToTop';
import PrivacyPolicy from '../features/PolicyPages/PrivacyPolicy';
import AboutUs from '../features/Pages/about/AboutUS';
import LoyaltyTerms from '../features/PolicyPages/LoyaltyTerms';
import ProducListCarpet from '../features/product/ProducListCarpet';
import Myprofile from '../features/Accounts/Myprofile';
import ChangePassword from '../features/auth/ChangePassword';
import WOW from "wowjs";
import MobileVirsioncart from "../features/product/component/Mobileview/MobileVirsioncart";
import Homepage from "../features/Home/Homepage";
import ProductList from "../features/product/ProducList";
import BottomPanel from "../Component/footer/BottomPanel";
import Footer from "../Component/footer/Footer";
import ProductGraid from "../features/ProductDetail/ProductGraid";
import { ProducListSecand } from "../features/product/ProducListSecand";
import MobileVersionGrid from "../features/product/component/Mobileview/MobileVirsionGrid";
import ProductDetails from "../features/ProductDetail/ProductDetails";
import Wishlist from "../features/Pages/wishlist/Wishlist";
import Navigationbar from "../Component/header/Navigationbar";
import ProtectedRoute from "./ProtectedRoute";

function AppRoutes() {
    useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, []);
  return (
    <> 
    <Router>
          <Navigationbar/> 
                <Routes>
                      <Route path="/" element={<Homepage/>} />
                      <Route path="/productListcarpet" element={<ProducListCarpet/>} />
                      <Route path="/productList" element={<ProductList/>} />
                      {/* <Route path="/productListsecand" element={<ProducListSecand/>} /> */}
                      <Route path="/:slug" element={<ProducListSecand />} />
                      <Route path="/productgraid" element={<ProductGraid/>} />
                      <Route path="/mobileGrid" element={<MobileVersionGrid/>} />
                      <Route path="/products/:slug" element={<ProductDetails />}/>
                       {/* <Route path="/product/:slug" element={<ProductDetails />} /> */}
                      <Route path="/wishlist" element={<Wishlist/>} />
                      <Route path="/checkout/cart" element={ <CheckOut/>} />
                      <Route path="/Cart" element={<MobileVirsioncart/>}/>
                      <Route path="/summary" element={<Summarys/>} />
                      <Route path="/about" element={<AboutUs/>} />
                      <Route path="/privacy" element={ <PrivacyPolicy/> } />
                      <Route path="/loyalty" element={ <LoyaltyTerms/> } />
                      <Route path="/my-profile" element={<Myprofile/>} />
                      <Route path="/ChangePassword" element={<ChangePassword/>} />
                   </Routes>
                      <Footer/>
                    <BottomPanel/>   
                  <ScrollToTop/>
        </Router>
    </>
  );
}
export default AppRoutes;
